import axios from "axios";

import { api } from "../../apis";
import { helperFunction } from "../../constant/helper";
import { types } from "../type";

// set loading
const setAttendanceLoading = (data) => (dispatch) => {
  dispatch({
    type: types.AttendanceTypes.ATTENDANCE_SET_LOADING,
    payload: data
  });
};

// clear result
const clearAttendanceResult = () => (dispatch) => {
  dispatch({
    type: types.AttendanceTypes.ATTENDANCE_CLEAR_RESULT
  });
};

// clear error
const clearAttendanceErrors = () => (dispatch) => {
  dispatch({
    type: types.AttendanceTypes.ATTENDANCE_CLEAR_ERRORS
  });
};

// unmount result
const unmountAttendanceData = () => (dispatch) => {
  dispatch({
    type: types.AttendanceTypes.ATTENDANCE_UNMOUNT
  });
};

const getFunction = async (
  url,
  type,
  errorType,
  dispatch,
  payloadData = []
) => {
  try {
    const getRequestSuccess = await axios.get(url);
    const { data } = getRequestSuccess;
    dispatch({
      type: type,
      payload: { data, payloadData }
    });
    // console.log(data);
  } catch (getRequestError) {
    const errorData = {
      data: getRequestError.response.data,
      status: getRequestError.response.status
    };
    dispatch({
      type: errorType,
      payload: errorData
    });
  }
};

// get  daily attendance
const getDailyAttendance = (
  date,
  locationId,
  loginType,
  dataToGetDailyAttendance,
  selectedCategory
) => async (dispatch) => {
  const { baseUrlNode } = await helperFunction.checkLoginType(
    loginType
  );
  const url = `${baseUrlNode}${api.Attendance_Api.GET_DAILY_ATTENDANCE_API}/${date}/${locationId}/${dataToGetDailyAttendance}/${loginType}`;
  const type = types.AttendanceTypes.GET_DAILY_ATTENDANCE;
  const errorType = types.AttendanceTypes.ATTENDANCE_GET_ERRORS;
  dispatch({
    type: types.AttendanceTypes.DAILY_ATT_INPUTS,
    payload: {
      date,
      locationId,
      selectedCategory
    }
  });
  getFunction(url, type, errorType, dispatch, selectedCategory);
};

// get  attendance sheet
const getAttendanceSheet = (
  fromDate,
  toDate,
  locationId,
  loginType,
  attendanceType,
  dataFormat
) => async (dispatch) => {
  const { baseUrlNode } = await helperFunction.checkLoginType(
    loginType
  );
  const url = `${baseUrlNode}${api.Attendance_Api.GET_ATTENDANCE_SHEET_API}/${fromDate}/${toDate}/${locationId}/${loginType}/${attendanceType}`;
  const type = types.AttendanceTypes.GET_ATTENDANCE_SHEET;
  const errorType = types.AttendanceTypes.ATTENDANCE_GET_ERRORS;
  dispatch({
    type: types.AttendanceTypes.SHEET_INPUTS,
    payload: {
      fromDate,
      toDate,
      locationId,
      dataFormat
    }
  });
  getFunction(url, type, errorType, dispatch);
};

// get dynamic attendance sheet
const getDynamicAttendanceSheet = (
  fromDate,
  toDate,
  locationId,
  loginType,
  dataType
) => async (dispatch) => {
  const { baseUrlNode } = await helperFunction.checkLoginType(
    loginType
  );
  const url = `${baseUrlNode}${api.Attendance_Api.GET_ATTENDANCE_DYNAMIC_SHEET_API}/${fromDate}/${toDate}/${locationId}/${loginType}/${dataType}`;
  const type = types.AttendanceTypes.GET_ATTENDANCE_DYNAMIC_SHEET;
  const errorType = types.AttendanceTypes.ATTENDANCE_GET_ERRORS;
  dispatch({
    type: types.AttendanceTypes.SHEET_INPUTS,
    payload: {
      fromDate,
      toDate,
      locationId
    }
  });
  getFunction(url, type, errorType, dispatch);
};

// get  attendance sheet
const getAllShiftActions = (
  fromDate,
  toDate,
  locationId,
  loginType
) => async (dispatch) => {
  const { baseUrlNode } = await helperFunction.checkLoginType(
    loginType
  );
  const url = `${baseUrlNode}${api.Attendance_Api.GET_SHIFT_SHEET_API}/${fromDate}/${toDate}/${locationId}/${loginType}`;
  const type = types.AttendanceTypes.GET_SHIFT_SHEET;
  const errorType = types.AttendanceTypes.ATTENDANCE_GET_ERRORS;
  dispatch({
    type: types.AttendanceTypes.SHEET_INPUTS,
    payload: {
      fromDate,
      toDate,
      locationId
    }
  });
  getFunction(url, type, errorType, dispatch);
};

// update shift sheet
const updateShiftAction = (shiftData, loginType) => async (
  dispatch
) => {
  try {
    const { baseUrlNode } = await helperFunction.checkLoginType(
      loginType
    );
    const updateShiftSuccess = await axios.post(
      `${baseUrlNode}${api.Attendance_Api.UPDATE_SHIFT_SHEET_API}/${loginType}`,
      shiftData
    );
    dispatch({
      type: types.AttendanceTypes.UPDATE_SHIFT_SHEET,
      payload: updateShiftSuccess.data
    });
  } catch (updateShiftError) {
    const errorData = {
      data: updateShiftError.response.data,
      status: updateShiftError.response.status
    };
    dispatch({
      type: types.AttendanceTypes.ATTENDANCE_GET_ERRORS,
      payload: errorData
    });
  }
};

// add missing attendance
const addMissingAttendance = (missingData, loginType) => async (
  dispatch
) => {
  try {
    const { baseUrlPython } = await helperFunction.checkLoginType(
      loginType
    );
    const addMissingAttendanceSuccess = await axios.post(
      `${baseUrlPython}${api.Attendance_Api.ADD_DAILY_MISSING_ATTENDANCE_API}`,
      missingData
    );
    dispatch({
      type: types.AttendanceTypes.ADD_DAILY_MISSING_ATTENDANCE,
      payload: addMissingAttendanceSuccess.data
    });
  } catch (addMissingAttendanceError) {
    const errorData = {
      data: addMissingAttendanceError.response.data,
      status: addMissingAttendanceError.response.status
    };
    dispatch({
      type: types.AttendanceTypes.ATTENDANCE_GET_ERRORS,
      payload: errorData
    });
  }
};

// get  daily attendance by department
const getDailyDepartmentAttendance = (values, loginType) => async (
  dispatch
) => {
  const { baseUrlNode } = await helperFunction.checkLoginType(
    loginType
  );
  const url = `${baseUrlNode}${api.Attendance_Api.GET_DAILY_DEPARTMENT_ATTENDANCE_API}/${values.date}/${values.locationId}/${values.dataType}/${loginType}`;
  const type = types.AttendanceTypes.GET_DAILY_DEPARTMENT_ATTENDANCE;
  const errorType = types.AttendanceTypes.ATTENDANCE_GET_ERRORS;
  dispatch({
    type: types.AttendanceTypes.DAILY_ATT_INPUTS,
    payload: {
      date: values.date,
      locationId: values.locationId
    }
  });
  getFunction(url, type, errorType, dispatch);
};

// add SINGLE missing attendance
const addSingleMissingAttendance = (missingData, loginType) => async (
  dispatch
) => {
  try {
    const { baseUrlNode } = await helperFunction.checkLoginType(
      loginType
    );
    const addMissingAttendanceSuccess = await axios.post(
      `${baseUrlNode}${api.Attendance_Api.ADD_DAILY_MISSING_ATTENDANCE_API}/${loginType}`,
      missingData
    );
    dispatch({
      type: types.AttendanceTypes.ADD_DAILY_SINGLE_MISSING_ATTENDANCE,
      payload: addMissingAttendanceSuccess.data
    });
  } catch (addMissingAttendanceError) {
    const errorData = {
      data: addMissingAttendanceError.response.data,
      status: addMissingAttendanceError.response.status
    };
    dispatch({
      type: types.AttendanceTypes.ATTENDANCE_GET_ERRORS,
      payload: errorData
    });
  }
};

export {
  updateShiftAction,
  getAllShiftActions,
  getAttendanceSheet,
  getDailyAttendance,
  setAttendanceLoading,
  addMissingAttendance,
  clearAttendanceErrors,
  clearAttendanceResult,
  unmountAttendanceData,
  getDynamicAttendanceSheet,
  addSingleMissingAttendance,
  getDailyDepartmentAttendance
};
